import Vue from "vue";
import waves from "./waves";

const install = function () {
  Vue.directive("waves", waves);
};

export default {
  install,
};
